import { Link } from "wouter";

export const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-full">
      <h1 className="text-4xl font-bold text-muted-foreground">404 Not Found</h1>
      <Link className="text-primary" href="/">
        Go Home
      </Link>
    </div>
  );
};
